import { observer } from 'mobx-react-lite'
import { SideSheetHostView } from '@/components/SideSheet'
import { type OpportunitiesViewModel } from '@/features/opportunities/OpportunitiesViewModel'
import { OpportunityDetailsSheetContainer } from './OpportunityDetailsSheetContainer'

export interface GlobalOpportunityDetailsSheetContainerProps {
  vm: OpportunitiesViewModel
}

/**
 * Hosted at the top of the tree, this will be used as the Op Details viewer when an Op is selected.
 * For example, if a notification comes in of a New Op, rather than redirect the user to Ops, we show
 * the sheet above the current page.
 */
export const GlobalOpportunityDetailsSheetContainer = observer(
  function GlobalOpportunityDetailsSheetContainer({
    vm,
  }: GlobalOpportunityDetailsSheetContainerProps) {
    const visible = !vm.isActive && !!vm.detailsVm.selected
    return (
      <SideSheetHostView
        mainless
        onRequestHide={vm.detailsVm.deselect}
        elevation="above"
        sheetVisible={visible}
      >
        <OpportunityDetailsSheetContainer
          onClose={vm.detailsVm.deselect}
          vm={vm.detailsVm}
        />
      </SideSheetHostView>
    )
  },
)
